import { Col, ConfigProvider, Row } from "antd";
import { MetadataRow } from "./metadata-row/metadata-row";
import { MetadataTemplateItem, MetadataRowItem, ContainerData } from "../../../api/data-types";

import "../../../App.css";
import { useEffect, useState } from "react";
import { StorageAPIClient } from "../../../api/storage-api-client";

const DEFAULT_CONTAINER_LABEL = "";

interface MetadataTableProps {
  isModal: boolean;
  theme: string;
  metadataItems: MetadataRowItem[];
  handleRemoveMetadataItem: (key: number) => void;
  handleItemChange: (key: number, metadataItem: MetadataRowItem) => void;
  isMassUpdate: boolean;
  selectedContainer: ContainerData;
}

export interface TableRef {
  handleAddItem: () => void;
}

export const MetadataTable = ({
  isModal,
  theme,
  metadataItems,
  handleRemoveMetadataItem,
  handleItemChange,
  isMassUpdate,
  selectedContainer,
}: MetadataTableProps) => {
  const [metadataKeysFromContainer, setMetadataKeysFromContainer] = useState<
    string[]
  >([]);

  const [metadataKeys, setMetadataKeys] = useState<string[]>([]);

  const handleAddMetadataKey = (keys: string[]) => {
    setMetadataKeys(keys);
  };

  useEffect(() => {
    if (
      selectedContainer.containerName !== "" &&
      selectedContainer.containerName !== DEFAULT_CONTAINER_LABEL
    ) {
      StorageAPIClient.getKeysFromContainer(selectedContainer.containerName)
        .then((metadataKeys) => {
          setMetadataKeysFromContainer(metadataKeys);
          setMetadataKeys(metadataKeys);
        })
        .catch((error) => {
          console.error("Error on mount:", error.message);
        });
    }
  }, [selectedContainer]);

  const textColor = theme === "light" ? "#000000" : "#ffffff";

  const metadataHeight = isModal ? "350" : "400";

  return (
    <Col span={24}>
    <div data-theme={theme}>
      <Row align="middle">
        <Col
          span={9}
          style={{
             
             color: textColor
          }}
        >
          Key:
        </Col>
        <Col
          span={11}
          style={{
         
             color: textColor
          }}
        >
          Value:
        </Col>
        {isMassUpdate && (
          <Col
            span={3}
            style={{
              fontSize: "14px",
              fontWeight: "500",
              textAlign: "center",
              color: textColor
            }}
          >
            To be removed:
          </Col>
        )}
      </Row>
      <div style={{overflow: "auto", maxHeight: `${metadataHeight}px`}}>
      {metadataItems.map((item, index) => (
        <div key={item.id}>
          <MetadataRow
            theme={theme}
            metadataItem={item}
            id={index}
            handleRemoveItem={handleRemoveMetadataItem}
            handleTableChange={handleItemChange}
            isMassUpdate={isMassUpdate}
            metadataKeys={metadataKeysFromContainer}
            editableMetadataKeys={metadataKeys}
            setMetadataKeys={handleAddMetadataKey}
          />
        </div>
      ))}
      </div>
    </div>
    </Col>
  );
};
